// extracted by mini-css-extract-plugin
module.exports = {"DataStoreOverview":"DataStoreOverview_ojwD9","DataStoreOverviewSpace":"DataStoreOverviewSpace_ErzAz"};